import React from "react";
import FormCardResults from "./FormCardResults";
import { Image } from "react-bootstrap";
import LightLogo from "../../images/light-logo.svg";

const LeftSection = () => {
  return (
    <div className="text-white d-flex flex-column align-items-start justify-content-center  h-100 logo-section">
     
      <Image src={LightLogo} alt="" className="position-absolute logo-img"/>
  
      <FormCardResults />
    </div>
  );
};

export default LeftSection;